import { graphql, useStaticQuery } from "gatsby";
/* eslint-disable react/no-unescaped-entities */
import React from "react";

import FocusServiceCard from "../../../components/cards/FocusServiceCard";
import { ConditionalSwiper } from "../../../components/shared/conditionalSwiper";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

const ProgramKeyMessaging = () => {
  const { keyMessageDetails } = useStaticQuery(graphql`
    query {
      keyMessageDetails: wp {
        globalProgramConfig: gviConfigSettings {
          acfKeyMessagingIcons {
            ...AcfKeymessagingiconsFragment
          }
        }
      }
    }
  `);

  const keyMessageIcons =
    keyMessageDetails?.globalProgramConfig?.acfKeyMessagingIcons?.kmiJourneys ??
    {};

  const breakpoint = useBreakpoint();

  return (
    <>
      <section className="w-full mr-auto md:!pr-4">
        {keyMessageIcons?.length > 0 && (
          <div className="grid gap-2 grid-cols-1 sm:grid-cols-4 py-8">
            <ConditionalSwiper
              condition={breakpoint === "xs"}
              slidesPerView={2.25}
              spaceBetween={10}
              centeredSlides={false}
              className="h-full w-full"
            >
              {keyMessageIcons &&
                keyMessageIcons.length > 0 &&
                keyMessageIcons.map((include, index) => (
                  <FocusServiceCard
                    key={index}
                    title={include.kmiJourneysTitle}
                    description={include.kmiJourneysDesc}
                    icon={include.kmiJourneysIcon}
                    containerClass="max-w-sm gvi-fservice-card flex flex-col h-full p-4  "
                    className="p-4"
                    contentClass="flex flex-col h-full"
                    contentTitleClass="w-full pb-4 text-xl font-normal font-alice text-generic-text dark:text-white "
                    titleClass=""
                    descriptionClass="text-generic-text dark:text-gray-generic xxs:text-xs"
                    imageClass=""
                    imageOuterContainerClass="fservice-card-icon w-[54px] h-[57px]"
                    imageContainerClass=""
                  />
                ))}
            </ConditionalSwiper>
          </div>
        )}
      </section>
    </>
  );
};

export default ProgramKeyMessaging;
